import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import {
  CContainer,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
  CHeaderText,
  CCard,
  CCardBody,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCart, cilMenu, cilSpeech } from '@coreui/icons'
import { AppHeaderDropdown, AppHeaderSearch } from './header'
import { useAuth } from '../hooks/useAuth'
import { openForumSso } from '../utils/forumSso'

const AppHeader = () => {
  const headerRef = useRef()
  const { Roles, checkRoles } = useAuth()
  const isMaster = checkRoles(Roles.MASTER)
  const isInstructor = checkRoles(Roles.INSTRUCTOR)
  const forumUrl = process.env.REACT_APP_FORUM_URL

  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
  )

  setInterval(() => {
    setCurrentTime(
      new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
    )
  }, 60000)

  useEffect(() => {
    document.addEventListener('scroll', () => {
      headerRef.current &&
        headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0)
    })
  }, [])

  return (
    <CHeader position="sticky" className="mb-4 p-0" ref={headerRef}>
      <CContainer className="px-3" fluid>
        <CCard className="card-light w-100">
          <CCardBody className="d-flex px-4 py-2">
            <CHeaderToggler
              className={classNames('d-lg-none', {
                'prevent-hide': !sidebarShow,
              })}
              onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
              style={{ marginInlineStart: '-14px' }}
            >
              <CIcon icon={cilMenu} size="lg" />
            </CHeaderToggler>
            {!isMaster && <AppHeaderSearch />}
            <CHeaderNav className="ms-auto">
              <CHeaderNav className="d-flex align-items-center me-3 gap-2">
                {forumUrl && !isInstructor && !isMaster && (
                  <CHeaderToggler
                    className="p-0 border-0"
                    onClick={openForumSso}
                    style={{
                      background: 'transparent',
                      color: 'inherit',
                    }}
                  >
                    <CIcon icon={cilSpeech} size="xl" className="text-primary" />
                  </CHeaderToggler>
                )}
                <CHeaderToggler
                  className="p-0 border-0"
                  onClick={() => window.open('https://kaneprofessional.com/catalog/', '_blank')}
                  style={{
                    background: 'transparent',
                    color: 'inherit',
                  }}
                >
                  <CIcon icon={cilCart} size="xl" className="text-primary" />
                </CHeaderToggler>
              </CHeaderNav>
              <CHeaderText className="p-0 text-primary fw-semibold fs-4 d-flex align-items-center">
                {currentTime}
              </CHeaderText>
              <AppHeaderDropdown />
            </CHeaderNav>
          </CCardBody>
        </CCard>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
